var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1458_18715)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.1404 17.0391C16.5828 17.0391 16.0479 16.8067 15.6536 16.3931C15.2593 15.9794 15.0377 15.4184 15.0377 14.8334C15.0377 14.0927 15.9451 12.5078 16.8056 11.2474C16.9674 11.0103 17.3135 11.0103 17.4753 11.2474C18.3357 12.5078 19.2432 14.0927 19.2432 14.8334C19.2432 15.4184 19.0216 15.9794 18.6273 16.3931C18.233 16.8067 17.6981 17.0391 17.1404 17.0391Z",
    fill: "#7100FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.35507 1.16891H13.7603C14.0388 1.16891 14.2646 1.3947 14.2646 1.67323V6.65941C14.2413 6.67496 14.2188 6.69327 14.1976 6.7145L10.6325 10.2796C10.5444 10.3677 10.5064 10.4766 10.5086 10.5827H5.35507C5.07655 10.5827 4.85076 10.3569 4.85076 10.0784V1.67323C4.85076 1.3947 5.07655 1.16891 5.35507 1.16891ZM4.59492 -0.00773674C4.94717 -0.00777844 5.23488 -0.0078125 5.35507 -0.0078125H13.7603C14.6887 -0.0078125 15.4413 0.744814 15.4413 1.67323V10.0784C15.4413 11.0068 14.6887 11.7595 13.7603 11.7595H5.35507C4.42667 11.7595 3.67404 11.0068 3.67404 10.0784V1.67323C3.67404 1.66783 3.67404 1.66247 3.67404 1.65714C3.6741 1.01361 3.67411 0.832708 2.83872 0.832862H2.41846C1.9998 0.832657 2 0.412652 2 0.412652C2.00001 -0.00740219 2.42009 -0.00763561 2.42009 -0.00763561C2.70985 -0.0075136 3.81186 -0.00764405 4.59492 -0.00773674Z",
    fill: "#110017"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1458_18715"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 17,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColor);
export default __webpack_public_path__ + "static/media/color.ec6ce71b3ad3e958074ea98bfbb3d18d.svg";
export { ForwardRef as ReactComponent };